export default __webpack_public_path__ + "static/media/services-referencement.c8ec8d04.svg";